import { Card, CardContent, Typography, Stack } from "@mui/material";
import { PointsWidget } from "./dashboard/PointsWidget";

export const Dashboard = () => (
    <>
         <Stack spacing={2} sx={{ p: 2, width: "100%", }}>
      <Typography variant="h5" fontWeight={700}>
        Punkte
      </Typography>
  <Card>

    <PointsWidget />

  </Card>
</Stack>
  </>
);
